import { Component, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LocalService } from '../../../services/shared/local.service';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { HttpErrorResponse } from '@angular/common/http';
import { MembershipService } from '../../../services/membership.service';
import { GlobalService } from '../../../services/shared/global.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';
import { CMClubService } from '../../../services/cm-club.service';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { MemPause, MemPauseListRequest, MemPauseResponse, REF_MemAccountStatus, REF_MemPauseType } from '../../../models/membership.model';
import { FormControl, FormGroup } from '@angular/forms';
import { UserDD } from '../../../models/generic-response.model';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-mem-pause-list',
    templateUrl: './mem-pause-list.component.html',
    styleUrls: ['./mem-pause-list.component.css']
})
/** mem-pause-list component*/
export class MemPauseListComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    memPauseListSource: MatTableDataSource<any>;
    memPauseListDisplayColumns: string[] = [];
    columns = [{ field: 'contactName', title: 'Name', width: '20' },
    { field: 'pauseType', title: 'Pause Type', width: '20' },
    { field: 'pauseStartDate', title: 'Pause Start Date', width: '80' },
    { field: 'pauseEndDate', title: 'Pause End Date', width: '150' },
    { field: 'pauseAmount', title: 'Pause Amount', width: '40' },
    { field: 'hardshipReasonID', title: 'Hardship Reason', width: '40' },
    { field: 'indefiniteReasonID', title: 'Indefinite Reason', width: '40' },]

    encryptedUser: string;
    user: BCMCLPUser;
    teamSub: Subscription;
    curTeam: TeamCodes = <TeamCodes>{};
    showSpinner: boolean;
    clubConfig: CMClub;
    memPauses: MemPause[];
    selectedCMSiteID: number = 0;
    users: number[];
    class4Code: any;
    clpUsersDD: UserDD[];
    selectedUserID: number = 0;
    pauseTypeID: number = 0;
    createDateFilters = [
        {
            "value": 1,
            "name": "This Month"
        },
        {
            "value": 2,
            "name": "Last Month"
        },
        {
            "value": 3,
            "name": "Custom"
        }
    ]
    customFilter: boolean = false;
    customDateStr: string = '';
    selectedCtDtFilterName: string;
    selectedCtDtFilter: number = 1;
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCustomdtStart: string;
    selectedCustomdtEnd: string;
    cmSites: CMSite[];
    sites: any[];
    ref_MemPauseType_List: REF_MemPauseType[];
    private destroy$ = new Subject<void>();

    constructor(private localService: LocalService,
        private membershipService: MembershipService,
        public _localService: LocalService,
        private _globalService: GlobalService,
        private _utilityService: UtilityService,
        private _teamOfficeService: TeamOfficeService,
        private userService: UserService,
        private _router: Router,
        private datePipe: DatePipe,
        private clubService: CMClubService
    ) {
        this.localService.setShowMenu(true);
        this.localService.setIsContract(false);
        this.localService.setIsMembership(true);
        this.localService.updateTeamDD(true);
        this.localService.setRouteName("mem-pause-list");
    }

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.loadData()
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    this.memPause_GetList();
                    await this.cLPUserGetListByTeamCode(this.user?.cLPCompanyID, this.curTeam?.teamCode);
                    this.ref_MemPauseType_List = this.localService.refMem_GetAllResponse.ref_MemPauseType_List;
                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    this.memPause_GetList();
                    await this.cLPUserGetListByTeamCode(this.user?.cLPCompanyID, this.curTeam?.teamCode);
                    this.ref_MemPauseType_List = this.localService.refMem_GetAllResponse.ref_MemPauseType_List;
                }
            }
        })
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            this.showSpinner = true
            await this.clubService.CMClub_Get(this.encryptedUser, this.user?.cLPCompanyID, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.cmSites = response?.sites;
                       
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async authenticateR() {
        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    setGrid(list) {
        this.memPauseListDisplayColumns = this.columns.map(c => c.field);
        this.memPauseListSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.memPauseListSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = 50;
            }
            if (this.sort) {
                this.memPauseListSource.sort = this.sort;
            }
        }, 500)

    }

    async memPause_GetList() {
        let memPauseListRequest: MemPauseListRequest = <MemPauseListRequest>{};
        memPauseListRequest.clubId = this.clubConfig?.clubId;
        memPauseListRequest.dateType = 1;
        memPauseListRequest.pauseTypeID = this.pauseTypeID;
        memPauseListRequest.sites = this.sites;
        memPauseListRequest.strdtEnd = this.selectedCustomdtEnd;
        memPauseListRequest.strdtStart = this.selectedCustomdtStart;
        memPauseListRequest.timeFrame = this.selectedCtDtFilter;
        memPauseListRequest.users = this.users;

        await this.membershipService.memPause_GetList(this.encryptedUser, memPauseListRequest, this.user?.cLPUserID)
            .then(async (result: MemPauseResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memPauses = response?.pauses;
                    this.setGrid(this.memPauses);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async onChangeUserDD() {
        if (this.selectedUserID > 0) {
            this.users = [];
            this.users.push(this.selectedUserID);
            await this.memPause_GetList();
        }
        else {
            this.users = [];
            await this.memPause_GetList();
        }
    }

    async onChangeCMSite() {
        if (this.selectedCMSiteID > 0) {
            this.sites = [];
            this.sites.push(this.selectedCMSiteID);
            await this.memPause_GetList();
        }
        else {
            this.sites = [];
            await this.memPause_GetList();
        }
    }

    async onChangeStatus() {
        await this.memPause_GetList();
    }

    async createDtFilterChange() {
        let value = this.selectedCtDtFilter;

        if (value != 3) {
            this.selectedCtDtFilter = +value;
            await this.memPause_GetList();
        }
        else {
            this.customDateStr = ''
            this.customFilter = true;
        }
    }

    revertCustomFinalizeddtFilter() {
        this.customFilter = false;
        this.selectedCtDtFilter = 1;
        this.selectedCtDtFilterName = "This Month";
        this.currentRange = new FormGroup({
            start: new FormControl<Date | null>(null),
            end: new FormControl<Date | null>(null),
        });
        this.memPause_GetList();
    }


    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
            this.selectedCustomdtStart = customdtStart;

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCustomdtEnd = customdtEnd;
            //this.selectedCtDtFilter = 3;
            this.selectedCtDtFilterName = "Custom"
            if (this.selectedCustomdtStart && this.selectedCustomdtEnd != null) {
                this.memPause_GetList();
            }
        }
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();
        if (this.memPauseListSource) {
            this.memPauseListSource.filter = filterValue;
        }
    }

    async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode ? teamCode : this.user?.cLPUserID).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--ALL--"
                    })
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    selectRow(row: any): void {
        if (!row?.pauseID) return;
        const url = `/mem-pause?pauseID=${row.pauseID}`;
        window.open(url, '_blank');
    }
    navToMemContact(contactID) {
        let url = 'mem-contact/' + contactID;
        window.open(url, '_blank');
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
